"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M19 1H1c-.6 0-1 .5-1 1v16c0 .5.4 1 1 1h18c.5 0 1-.5 1-1V2c0-.5-.5-1-1-1zm-1 16H2v-3h16v3zm0-4H2v-3h16v3zm0-4H2V6h16v3z"];
//# sourceMappingURL=th-list.js.map